import req from 'shared/req';
import {
  EDIT_COLLEGE_SUCCESS_ITEM,
  REMOVE_COLLEGE_SUCCESS_ITEM,
} from 'shared/portfolio/actions/college-success-items';

export const createItem = (data, fields) => (dispatch) =>
  req({
    url: '/v1/users/me/time-sensitive-items',
    method: 'post',
    data: {...data, fields},
  }).then((item) => {
    dispatch({
      type: EDIT_COLLEGE_SUCCESS_ITEM,
      item,
    });
  });

export const updateItem = (_id, data, fields) => (dispatch) =>
  req({
    url: `/v1/users/me/time-sensitive-items/${_id}`,
    method: 'patch',
    data: {...data, fields},
  }).then((item) => {
    dispatch({
      type: EDIT_COLLEGE_SUCCESS_ITEM,
      item,
    });
  });

export const deleteItem = (_id) => (dispatch) =>
  req({
    url: `/v1/users/me/time-sensitive-items/${_id}`,
    method: 'delete',
  }).then(() => {
    dispatch({
      type: REMOVE_COLLEGE_SUCCESS_ITEM,
      _id,
    });
  });
